import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FLETE_EXTERNO_COSTO_FIJO } from "../../../../../../utility/constants";
import { FleteExternoApi } from "../api/FleteExternoApi";

/**
 * Maneja el formulario de precios de flete ajeno al productor de una finca.
 * @param {*} finca - Finca seleccionada en el listado
 * @param {*} onGuardado - Se ejecuta cuando los precios se guardaron correctamente
 */
export const useFleteExternoForm = (finca, onGuardado) => {
    const { actualizarFleteExterno, cargando } = FleteExternoApi();

    const {
        control,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: { errors },
    } = useForm({ mode: "onChange" });

    // Al abrir el modal se cargan los precios de la finca seleccionada
    useEffect(() => {
        if (!finca) return;

        reset({
            tipo_costo_flete_externo_latex:
                finca.tipo_costo_flete_externo_latex ||
                FLETE_EXTERNO_COSTO_FIJO,
            costo_flete_externo_latex: finca.costo_flete_externo_latex || 0,
            tipo_costo_flete_externo_solido:
                finca.tipo_costo_flete_externo_solido ||
                FLETE_EXTERNO_COSTO_FIJO,
            costo_flete_externo_solido: finca.costo_flete_externo_solido || 0,
        });
    }, [finca]);

    const onSubmit = async (values) => {
        // Un precio vacío significa que la finca no tiene precio de flete ajeno
        const data = {
            tipo_costo_flete_externo_latex:
                values.tipo_costo_flete_externo_latex,
            costo_flete_externo_latex:
                parseFloat(values.costo_flete_externo_latex) || 0,
            tipo_costo_flete_externo_solido:
                values.tipo_costo_flete_externo_solido,
            costo_flete_externo_solido:
                parseFloat(values.costo_flete_externo_solido) || 0,
        };

        const exito = await actualizarFleteExterno(finca.id, data);
        if (exito) onGuardado();
    };

    return {
        control,
        errors,
        watch,
        setValue,
        cargando,
        guardar: handleSubmit(onSubmit),
    };
};
